/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyHandlingTimeMetafieldMapping
 */
export interface ShopifyHandlingTimeMetafieldMapping {
  /**
   *
   * @type {string}
   * @memberof ShopifyHandlingTimeMetafieldMapping
   */
  namespace: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyHandlingTimeMetafieldMapping
   */
  key: string;
}

/**
 * Check if a given object implements the ShopifyHandlingTimeMetafieldMapping interface.
 */
export function instanceOfShopifyHandlingTimeMetafieldMapping(
  value: object,
): value is ShopifyHandlingTimeMetafieldMapping {
  if (!("namespace" in value) || value["namespace"] === undefined) return false;
  if (!("key" in value) || value["key"] === undefined) return false;
  return true;
}

export function ShopifyHandlingTimeMetafieldMappingFromJSON(
  json: any,
): ShopifyHandlingTimeMetafieldMapping {
  return ShopifyHandlingTimeMetafieldMappingFromJSONTyped(json, false);
}

export function ShopifyHandlingTimeMetafieldMappingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyHandlingTimeMetafieldMapping {
  if (json == null) {
    return json;
  }
  return {
    namespace: json["namespace"],
    key: json["key"],
  };
}

export function ShopifyHandlingTimeMetafieldMappingToJSON(
  json: any,
): ShopifyHandlingTimeMetafieldMapping {
  return ShopifyHandlingTimeMetafieldMappingToJSONTyped(json, false);
}

export function ShopifyHandlingTimeMetafieldMappingToJSONTyped(
  value?: ShopifyHandlingTimeMetafieldMapping | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    namespace: value["namespace"],
    key: value["key"],
  };
}
